import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { bootTelegram } from './lib/telegram';

import './styles/global.css';
import './styles/app.css';

// Tell Telegram we're ready + paint the chrome before React mounts.
// Safe outside Telegram — no-ops via the wrapper.
bootTelegram();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('No #root element to mount into.');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
